/* import { LoginComponent } from "components/Header/LoginComponent"; */

import {
  DashboardTypes,
  DeleteStoredQueryMutation,
  GetPublishedOutputQuery,
  Placeholder,
  SwitchUserModeMutation,
  UserMode,
} from 'API';
import { API, button } from 'aws-amplify';
import Comments from 'components/Comments/Comments';
import { Selections } from 'components/Main/table/TableStyles';
import AddCampaignModal from 'components/NewPortal/Header/AddCampaignModal';
import EditCampaignModal from 'components/NewPortal/Header/EditCampaignModal';
import PickTemplate from 'components/Template/pickTemplate';
import SaveTemplate from 'components/Template/saveTemplate';
import { DarkButton, IconButton } from 'components/style/Global';
import APIContext from 'context/APIContext';
import { useCampaignContext } from 'context/CampaignContext';
import { useClientContext } from 'context/ClientContext';
import ClientStatementsContext from 'context/ClientStatementsContext';
import { CommentsContext } from 'context/CommentsContext';
import InputContext from 'context/InputContext';
import { usePortalContext } from 'context/PortalContext';
import { PublishContext } from 'context/PublishContext';
import { deleteStoredQuery } from 'graphql/mutations';
import { useContext, useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { CampaignSelectComponent, CustomSelect } from './CampaignSelectComponent';
import {
  ClientsContainer,
  Container,
  Content,
  FilterContainer,
  IconButtonContainer,
  StyledHeader,
} from './Header.styled';
import { useTemplateContext } from 'context/TemplateContext';
import { useGetSummaryStatus } from 'customHooks/useGettSummaryStatus';
import { set } from 'lodash';
import { getPublishedOutput } from 'graphql/queries';
import DeleteConfirmationModal from 'components/DeleteConfirmationModall';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { iconList } from 'assets/newAssets/SVG/additionalIconsForLinks/iconList';
import AddCampaignPeriodModal from 'components/NewPortal/AddCampaignPeriodModal';
import AddCustomReport from 'components/NewPortal/AddCustomReport';
import { useVideoParams } from 'customHooks/useParameters';
import { useFetchStoredQueries } from 'customHooks/useGetStoredQueriesDetails';

const Header = (props: any) => {
  const {
    reducedClientList,
    activeCampaign,
    dashType,
    setTVStationSelector,
    setRadioStationSelector,
    clientFilterList,
    filterCampaignsPerClientCode,
    setClientFilterList,
    endDateFilter,
    startDateFilter,
    setStartDateFilter,
    setEndDateFilter,
    setOrder,
    order,
    permanentCampaignList,
    activeSubCampaign,
    canDoInsourceAndOnInsourcePortal,
  } = useCampaignContext();
  const { activeOrganization, loggedInUserAccessType, userCanDoInsource, anyPublish } = useClientContext();
  const [toggleComment, setToggleComment] = useState(false);
  const { commentsList } = useContext(CommentsContext);
  const { publishCampaign, unpublishCampaign, isPublished, placeholders, placeholdersStatus } =
    useContext(PublishContext);
  const { statements } = useContext(ClientStatementsContext);
  const { getEnvironment } = useContext(APIContext);
  const {
    TVKPI,
    RADIOKPI,
    PRINTKPI,
    OOHKPI,
    networkList,
    dataSourceLength,
    organisationReportActive,
    setVideoDashboardView,
    videoDashboardView,
  } = useContext(InputContext);
  const [pickTemplateDisplay, setPickTemplateDisplay] = useState(false);
  const [saveTemplateDisplay, setSaveTemplateDisplay] = useState(false);
  const [error, setError] = useState('warning');
  const [seeModal, setSeeModal] = useState(false);
  const { editCampaign } = usePortalContext();
  const [publishedData, setPublishedData] = useState<Placeholder[]>();
  const [videoSource] = useVideoParams();

  // const placeholdersLength = (dashType === "RADIO" || dashType === "TV") ? 8 : (dashType === "PRINT" || dashType === "OOH" || dashType === "CINEMA") ? 2 : 0;
  // const isPublishButtonDisabled = placeholders ? placeholders[dashType as keyof typeof placeholders]?.length !== placeholdersLength ? true : false : true

  const isPublishButtonDisabled = placeholdersStatus.some((e) => e.loaded === false);

  useEffect(() => {
    if (activeCampaign) {
      const fetchPublishedData = async () => {
        try {
          const response = (await API.graphql({
            query: getPublishedOutput,
            variables: {
              clientCode: activeCampaign?.ClientCode,
              clientCountry: activeCampaign?.ClientCountry,
              campaign_id: activeCampaign?.campaignId,
              dashboardType:
                dashType === DashboardTypes.INSOURCE_DATA
                  ? DashboardTypes.DIGITAL
                  : videoSource === 'BVOD' && dashType === DashboardTypes.TV
                    ? DashboardTypes.BVOD // <-- Provjeri da li ovo radi
                    : DashboardTypes[dashType as keyof typeof DashboardTypes],
              subCampaignId:
                dashType === 'TV' && videoSource === 'BVOD' ? '-1' : activeSubCampaign?.subcampaignId?.toString(),
            },
            authMode: 'AMAZON_COGNITO_USER_POOLS',
          })) as { data: GetPublishedOutputQuery };
          const placeholdersData = response.data.getPublishedOutput?.placeholders;
          if (placeholdersData) {
            setPublishedData(placeholdersData as Placeholder[]);
          }
        } catch (e) {
          console.error(e);
        }
      };
      setToggleComment(false);
      fetchPublishedData();
    }
  }, [activeCampaign, activeSubCampaign?.subcampaignId, dashType]);

  async function handleRemoveQ(position: string) {
    try {
      const deleteQueries = (await API.graphql({
        query: deleteStoredQuery,
        variables: {
          campaign_id: activeSubCampaign?.name ? activeSubCampaign.subcampaignId : activeCampaign?.campaignId,
          Environment: getEnvironment,
          placeholder: position,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteStoredQueryMutation };
      if (deleteQueries.data.deleteStoredQuery?.StatusCode === 200) {
        console.log(`Successfully deleted queries for position: ${position}`);
        return true;
      }
      return false;
    } catch (e) {
      console.log(`PROBLEM DELETING QUERIES FOR POSITION ${position}`, e);
      return false;
    }
  }

  interface IFilter {
    code: string;
    country: string;
  }
  const [a, setA] = useState<Array<IFilter>>([]);
  const handleClientCodes = (event: any) => {
    const obj: IFilter = {
      code: event.target.value,
      country: event.target.name,
    };
    event.target.checked
      ? setA((a) => [...a, obj])
      : setA((a) => [...a.filter((el) => !(el?.code === event.target.value && el?.country === event.target.name))]);
  };
  useEffect(() => {
    filterCampaignsPerClientCode(a);
  }, [a]);

  useEffect(() => {
    setClientFilterList([]);
  }, [activeOrganization]);

  //transform dashType so that first letter is uppercase and the rest is lowercase
  const dashTypeTransformed = dashType !== null && dashType?.charAt(0).toUpperCase() + dashType?.slice(1).toLowerCase();
  const [openFilter, setOpenFilter] = useState(false);

  // create date value in format YYYY-MM-DD for 1st of January of current year, 31st of December of current year, 3 months ago, 6 months ago and 18 months ago
  // create date value in format YYYY-MM-DD for 1st of January of current year, 31st of December of current year, 3 months ago, 6 months ago and 18 months ago
  const currentDate = new Date();
  //turn current date into a string in the format "yyyy-mm-dd"

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Add 1 to the month to get a 1-based index
  const currentDay = currentDate.getDate();
  const currentYearStartDate = new Date(currentYear, 0, 1).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const currentYearEndDate = new Date(currentYear, 11, 31).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const threeMonthsAgo = new Date(currentYear, currentMonth - 3, currentDay).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const sixMonthsAgo = new Date(currentYear, currentMonth - 6, currentDay).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const eighteenMonthsAgo = new Date(currentYear, currentMonth - 18, currentDay).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  // find the newst endDate from permanentCampaignList

  const getendDate = () => {
    if (permanentCampaignList) {
      const endDateArray = permanentCampaignList?.map((el) => el?.endDate as string);
      const maxEndDate =
        endDateArray &&
        (endDateArray?.reduce((a, b) => {
          return a > b ? a : b;
        }) as string);
      // add 5 days to the maxEndDate
      const newDate = new Date(maxEndDate);
      newDate.setDate(newDate.getDate() + 5);
      const newDateTransformed = newDate.toISOString().substring(0, 10);
      return newDateTransformed;
    }
  };
  /*   const endDateArray = permanentCampaignList && permanentCampaignList?.map((el) => el?.endDate as string)
    const maxEndDate = endDateArray && endDateArray?.reduce((a, b) => {
      return a > b ? a : b
    }) as string */
  // const currentDate = new Date().toISOString().split('T')[0];

  // const publishedCampaignList = ['2021-01-01', '2021-02-01', '2021-03-01', '2021-04-01'];
  // const publishedTime = publishedData.

  const date = publishedData
    ? publishedData.length > 0 && publishedData[0].publishedAt
      ? publishedData[0].publishedAt.split(' ')[0]
      : undefined
    : undefined;
  // const date = undefined

  const publishedCampaignList = date === undefined ? undefined : [date];

  const options = publishedCampaignList
    ? publishedCampaignList.map((date) => ({ value: date, label: `Published on ${date}` }))
    : [];

  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handleCampaignChange = (option: any) => {
    setSelectedOption(option);
  };

  const { toggleDrag, isDragEnabled } = useTemplateContext();

  //hook that will check if SUMMARY HAS BEEN PUBLISHED
  const [isSummaryPublished] = useGetSummaryStatus(activeCampaign);
  const [bubleVisible, setBubleVisible] = useState(false);
  const handleBuble = () => {
    setBubleVisible(!bubleVisible);
    setTimeout(() => {
      setBubleVisible(false);
    }, 3000);
  };
  const fetchStored = useFetchStoredQueries(activeCampaign).fetchStoredQueries;
  const [deleteLinkModal, setDeleteLinkModal] = useState(false);
  const handleDeleteConfirmationModal = async (a: boolean) => {
    if (a) {
      try {
        const res = await fetchStored();
        console.log('RESPONSE FROM STORED QUERIES', res);

        let validPositions;

        if (dashType === 'DIGITAL') {
          // Filter positions that start with "1", "2", or "3" for DIGITAL dashboard
          validPositions = res
            ?.filter(
              (item: any) =>
                item.position &&
                (item.position.startsWith('1') || item.position.startsWith('2') || item.position.startsWith('3')),
            )
            .map((item: any) => item.position.charAt(0)) // Get first character (1, 2, or 3)
            .filter((value: string, index: number, array: string[]) => array.indexOf(value) === index); // Remove duplicates
        } else if (dashType === 'SEARCH') {
          // Filter positions that start with "Search" for SEARCH dashboard
          validPositions = ['Search'];
        }

        if (validPositions && validPositions.length > 0) {
          // Recursive function to delete queries one by one
          const deleteRecursively = async (positions: string[], index: number = 0): Promise<void> => {
            if (index >= positions.length) {
              unpublishCampaign();
              window.location.reload();
              return;
            }

            const success = await handleRemoveQ(positions[index]);
            if (success) {
              console.log(`Deleted position ${positions[index]}`);
            }

            // Continue with next position
            await deleteRecursively(positions, index + 1);
          };

          await deleteRecursively(validPositions);
        }

        setDeleteLinkModal(false);
      } catch (error) {
        console.error('Error in delete process:', error);
        setDeleteLinkModal(false);
      }
    } else {
      setDeleteLinkModal(a);
    }
  };

  console.log("KITATITA", loggedInUserAccessType, activeCampaign?.ClientCode)
  const fullAccessOnThisClientCode =
    loggedInUserAccessType?.Access?.find((lev) => lev?.Level === 'FULL_ACCESS')?.Clients?.some(
      (client) => client?.ClientCode === activeCampaign?.ClientCode,
    ) || false;

  const canDoInsourceAndOnDigital = userCanDoInsource && dashType === DashboardTypes.DIGITAL;
  const draggingIcon = iconList.find((icon) => icon === 'drag_pan');
  const loadTemplate = iconList.find((icon) => icon === 'cloud_sync');
  const saveTemplate = iconList.find((icon) => icon === 'bookmark_flag');
  const comments = iconList.find((icon) => icon === 'speaker_notes');
  const deleteIcon = iconList.find((icon) => icon === 'delete');
  const addTimeCampaign = iconList.find((icon) => icon === 'more_time');

  const [addCampaignPeriodModal, setAddCampaignPeriodModal] = useState(false);
  const [addCustomReportModal, setAddCustomReportModal] = useState(false);
  // const [videoDashboardView, setVideoDashboardView] = useState<string>('TV');

  return (
    <StyledHeader>
      <Content key={activeCampaign?.campaign}>
        <div style={{ marginLeft: '0.6rem', marginTop: '0.6rem', marginBottom: '0.2rem' }}>
          <h3>{activeOrganization?.Organization ? activeOrganization?.Organization : 'Please select a client'}</h3>
        </div>

        {dashType === DashboardTypes.FLOWCHART || dashType === DashboardTypes.OVERWRITE ? (
          <IconButtonContainer
            style={{ display: 'flex', alignItems: 'flex-end', paddingTop: '7px' }}
          ></IconButtonContainer>
        ) : (
          <div
            style={{
              borderRadius: '5px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {dataSourceLength !== 0 && (
              <IconButtonContainer>
                {activeCampaign &&
                  (fullAccessOnThisClientCode || canDoInsourceAndOnInsourcePortal) &&
                  (dashType === DashboardTypes.DIGITAL ||
                    dashType === DashboardTypes.SEARCH ||
                    dashType === DashboardTypes.INSOURCE_DATA) && (
                    <IconButton
                      title={isDragEnabled ? 'Disable Dragging' : 'Enable Dragging'}
                      style={{ border: isDragEnabled ? '1px solid #4CAF50' : '' }}
                      onClick={toggleDrag}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: '14px', color: isDragEnabled ? '#4CAF50' : '' }}
                      >
                        {draggingIcon}
                      </span>
                      Drag
                    </IconButton>
                  )}

                {activeCampaign &&
                  ((fullAccessOnThisClientCode &&
                    (dashType === DashboardTypes.DIGITAL ||
                      dashType === DashboardTypes.INSOURCE_DATA ||
                      dashType === DashboardTypes.SEARCH)) ||
                    canDoInsourceAndOnInsourcePortal) && (
                    <>
                      <IconButton title="Choose template" onClick={() => setPickTemplateDisplay(true)}>
                        <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                          {loadTemplate}
                        </span>
                        Templates
                      </IconButton>
                      <IconButton title="Save template" onClick={() => setSaveTemplateDisplay(true)}>
                        <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                          {saveTemplate}
                        </span>
                        Save Template
                      </IconButton>
                    </>
                  )}
                {activeCampaign &&
                  (statements?.Comment?.WRITE || canDoInsourceAndOnInsourcePortal) /* ||
                (activeCampaign &&
                  statements?.Comment?.READ &&
                  commentsList?.some((el) => el.placeholder.includes('0'))) */ && (
                    <>
                      <IconButton title="Comments" onClick={() => setToggleComment(!toggleComment)}>
                        <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                          {comments}
                        </span>
                        Comments
                      </IconButton>
                      {commentsList ? (
                        <Comments
                          header={true}
                          toggleComment={toggleComment}
                          componentID={
                            dashType === 'DIGITAL' /* || dashType === 'SEARCH' */ || dashType === 'INSOURCE_DATA'
                              ? '0'
                              : `${dashTypeTransformed}0`
                          }
                          setToggleComment={(toggleComment: boolean) => setToggleComment(toggleComment)}
                        ></Comments>
                      ) : null}
                    </>
                  )}
                {activeCampaign &&
                  (dashType === DashboardTypes.DIGITAL ||
                    dashType === DashboardTypes.INSOURCE_DATA ||
                    dashType === DashboardTypes.SEARCH) &&
                  (fullAccessOnThisClientCode || canDoInsourceAndOnInsourcePortal) && (
                    <IconButton
                      title="Delete Stored Queries"
                      onClick={() => {
                        setDeleteLinkModal(true);
                      }}
                    >
                      <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                        {deleteIcon}
                      </span>
                      Delete
                    </IconButton>
                  )}
                {statements?.Queries?.CREATE && dashType === 'TV' && videoSource !== 'BVOD' && activeCampaign && (
                  <>
                    {' '}
                    {TVKPI && Object.keys(TVKPI).length > 0 && (
                      <h1
                        style={{
                          fontSize: '12px',
                          fontFamily: 'fontBold',
                          // border: '1px solid blue',
                          // width: '300px',
                          // justifyContent: 'end',
                          textAlign: 'end',
                        }}
                      >{`${new Date(TVKPI.Startdate).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      })} - ${new Date(TVKPI.Enddate).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      })} | ${TVKPI.primary_target_group} | POP:${new Intl.NumberFormat('en-DK', {
                        maximumFractionDigits: 0,
                      }).format(TVKPI.universe_primary_target)}`}</h1>
                    )}
                  </>
                )}

                {activeCampaign &&
                  (activeCampaign.authorized || canDoInsourceAndOnInsourcePortal) &&
                  (statements?.Queries?.PUBLISH || canDoInsourceAndOnInsourcePortal) && (
                    <Container style={{ display: 'flex', width: 'fit-content' }}>
                      {
                        /* !isPublishButtonDisabled &&
                         */ !isPublished && (statements?.Queries?.PUBLISH || canDoInsourceAndOnInsourcePortal) && (
                          <DarkButton
                            className="publish"
                            style={{ height: '50%', alignSelf: 'end' }}
                            onClick={() => publishCampaign()}
                            // disabled={isPublishButtonDisabled}
                          >
                            Publish
                          </DarkButton>
                        )
                      }
                      {/*     {canDoInsourceAndOnDigital && (
                    <> */}
                      {((isPublished && statements?.Queries?.UNPUBLISH && !userCanDoInsource) ||
                        (isPublished && canDoInsourceAndOnInsourcePortal)) && (
                        /* !canDoInsourceAndOnDigital && */ <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div style={{ fontSize: '12px' }}>
                            {publishedCampaignList !== undefined ? (
                              <>
                                {publishedCampaignList.length > 1 ? (
                                  <CustomSelect
                                    options={options}
                                    value={selectedOption}
                                    onChange={handleCampaignChange}
                                    className="react-select-container"
                                    id="published"
                                    classNamePrefix="react-select"
                                  />
                                ) : (
                                  <div className="previewPublished">Published on {publishedCampaignList[0]}</div>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                          {isSummaryPublished ? (
                            <div className="unpublishHolder">
                              <button onClick={handleBuble}>Unpublish</button>
                              <span className="buble">
                                <span className="bubletext" style={{ visibility: bubleVisible ? 'visible' : 'hidden' }}>
                                  Summary has been published, please unpublish it first in order to unpublish this
                                  report.
                                </span>
                              </span>
                            </div>
                          ) : (
                            <button onClick={unpublishCampaign}>Unpublish</button>
                          )}
                        </div>
                      )}
                      {/*      </>
                  )} */}
                    </Container>
                  )}
              </IconButtonContainer>
            )}
          </div>
        )}
      </Content>

      <Content key={activeOrganization?.Organization}>
        {/* <div> */}
        {dashType !== DashboardTypes.FLOWCHART && (
          <>
            {' '}
            <IconButton title="Filters" onClick={() => setOpenFilter(!openFilter)}>
              <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                filter_alt
              </span>
              Filters
            </IconButton>
            {dashType !== DashboardTypes.TV && dashType !== DashboardTypes.RADIO && activeCampaign?.authorized && (
              <IconButton title="Add Date Report" onClick={() => setAddCampaignPeriodModal(true)}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  {addTimeCampaign}
                </span>
                Date Report
              </IconButton>
            )}
          </>
        )}

        {openFilter && (
          <div style={{ display: openFilter ? 'block' : 'none' }}>
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: '100',
                content: '',
              }}
              onClick={() => setOpenFilter(!openFilter)}
            ></div>
            <FilterContainer>
              <button type="button" className="x" onClick={() => setOpenFilter(false)}>
                <IoMdClose className="closeIcon" />
              </button>

              <section>
                <h1 className="title">Client Filter</h1>
                <ClientsContainer>
                  {reducedClientList?.map((e, index) => (
                    <Selections key={e?.campaignId}>
                      <input
                        type="checkbox"
                        checked={clientFilterList.some(
                          (el) => el?.code === e?.ClientCode && el?.country === e?.ClientCountry,
                        )}
                        value={e?.ClientCode as string}
                        name={e?.ClientCountry as string}
                        onChange={handleClientCodes}
                      />
                      <span className="tooltip">
                        {e?.ClientCode} {e?.ClientCountry}
                        <span className="tooltiptext">{e?.ClientName}</span>
                      </span>
                    </Selections>
                  ))}
                </ClientsContainer>
              </section>

              <section>
                <h1 className="title">Date Filter</h1>
                <div className="sectionContent" style={{ flexDirection: 'column' }}>
                  <div style={{ flexDirection: 'row', display: 'flex' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '1vw', gap: '.1vw' }}>
                      <h5>Start Date</h5>
                      {/* <input value={startDateFilter} onChange={(e) => setStartDateFilter(e.target.value)} type="date" /> */}
                      <DatePicker
                        className="datepicker"
                        dateFormat="dd-MM-yyyy"
                        selected={startDateFilter}
                        onChange={(e: any) => setStartDateFilter(e.toISOString().slice(0, 10))}
                        calendarStartDay={1}
                      />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <h5>End Date</h5>
                      {/* <input value={endDateFilter} onChange={(e) => setEndDateFilter(e.target.value)} type="date" /> */}
                      <DatePicker
                        className="datepicker"
                        dateFormat="dd-MM-yyyy"
                        selected={endDateFilter}
                        onChange={(e: any) => setEndDateFilter(e.toISOString().slice(0, 10))}
                        calendarStartDay={1}
                      />
                    </div>
                  </div>
                  <div style={{ flexDirection: 'row', display: 'flex', gap: '5px', marginTop: '5px' }}>
                    <button
                      type="button"
                      onClick={() => {
                        setStartDateFilter(currentYearStartDate);
                        setEndDateFilter(currentYearEndDate);
                      }}
                      style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
                    >
                      Current year
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setStartDateFilter(eighteenMonthsAgo);
                        setEndDateFilter(getendDate() as string);
                      }}
                      style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
                    >
                      Max
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setStartDateFilter(threeMonthsAgo);
                        setEndDateFilter(currentDate.toISOString().substring(0, 10));
                      }}
                      style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
                    >
                      Last 3 months
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setStartDateFilter(sixMonthsAgo);
                        setEndDateFilter(currentDate.toISOString().substring(0, 10));
                      }}
                      style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
                    >
                      Last 6 months
                    </button>
                  </div>
                  <div></div>
                </div>
              </section>

              <section>
                <h1 className="title">Sort by Date</h1>

                <ClientsContainer>
                  <Selections htmlFor="desc">
                    <input name="order" value="desc" id="desc" type="radio" defaultChecked={order === 'desc'} />
                    <span onClick={() => setOrder('desc')}>NEWEST FIRST</span>
                  </Selections>

                  <Selections htmlFor="asc">
                    <input name="order" value="asc" type="radio" id="asc" defaultChecked={order === 'asc'} />
                    <span onClick={() => setOrder('asc')}>OLDEST FIRST</span>
                  </Selections>
                </ClientsContainer>
              </section>
            </FilterContainer>
          </div>
        )}

        <CampaignSelectComponent clientFilterList={clientFilterList}></CampaignSelectComponent>

        <div>
          {
            /* statements?.Queries?.CREATE && */ dashType === 'TV' && activeCampaign && (
              <IconButtonContainer style={{ gap: '1vw' }}>
                {/* {TVKPI && Object.keys(TVKPI).length > 0 && (
                <h1
                  style={{
                    fontSize: '12px',
                    fontFamily: 'fontBold',
                    // border: '1px solid blue',
                    width: '300px',
                    justifyContent: 'end',
                    textAlign: 'end',
                  }}
                >{`${new Date(TVKPI.Startdate).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} - ${new Date(TVKPI.Enddate).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} | ${TVKPI.primary_target_group} | POP:${new Intl.NumberFormat('en-DK', {
                  maximumFractionDigits: 0,
                }).format(TVKPI.universe_primary_target)}`}</h1>
              )} */}
                {statements?.Queries?.CREATE && networkList.length > 0 && videoDashboardView === 'TV' && (
                  <select
                    style={{ marginRight: '4px' }}
                    name=""
                    id=""
                    onChange={(e) => setTVStationSelector(e.target.value)}
                  >
                    <option value="All stations">All stations</option>
                    {networkList.map((net: any) => (
                      <option key={net} value={net}>
                        {net}
                      </option>
                    ))}
                  </select>
                )}
                <select
                  style={{ marginRight: '4px' }}
                  name="tv-station"
                  id="tv-station"
                  value={videoDashboardView}
                  onChange={(e) => setVideoDashboardView(e.target.value)}
                >
                  {/* {(['TV', 'BVOD'] as DashboardTypes[]).map((type) => { */}
                  {activeCampaign.dashboardType
                    .filter((type) => ['TV', 'BVOD'].includes(type as string))
                    .map((type) => {
                      let enabled = false;
                      if (activeCampaign.authorized) {
                        enabled = true;
                      } else if (type === 'BVOD') {
                        enabled = activeCampaign.subcampaign[-1]?.published?.BVOD === true;
                      } else if (type === 'TV') {
                        enabled = Object.values(activeCampaign.subcampaign).some((sc) => sc.published?.TV === true);
                      }
                      return (
                        <option key={type} value={type as string} disabled={!enabled}>
                          {type}
                        </option>
                      );
                    })}
                </select>
              </IconButtonContainer>
            )
          }
          {statements?.Queries?.CREATE && dashType === 'RADIO' && activeCampaign && (
            <IconButtonContainer style={{ gap: '1vw' }}>
              {RADIOKPI && Object.keys(RADIOKPI).length > 0 && (
                <h1 style={{ fontSize: '12px', fontFamily: 'fontBold' }}>{`${new Date(
                  RADIOKPI.Startdate,
                ).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} - ${new Date(RADIOKPI.Enddate).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} | ${RADIOKPI.primary_target_group} | POP:${new Intl.NumberFormat('en-DK', {
                  maximumFractionDigits: 0,
                }).format(RADIOKPI.universe_primary_target)}`}</h1>
              )}

              {networkList.length > 0 && (
                <select
                  style={{ marginRight: '4px' }}
                  name=""
                  id=""
                  onChange={(e) => setRadioStationSelector(e.target.value)}
                >
                  <option value="All stations">All stations</option>
                  {networkList.map((net: any) => (
                    <option key={net} value={net}>
                      {net}
                    </option>
                  ))}
                </select>
              )}
            </IconButtonContainer>
          )}
          {statements?.Queries?.CREATE && dashType === 'PRINT' && activeCampaign && (
            <IconButtonContainer style={{ gap: '1vw' }}>
              {PRINTKPI && Object.keys(PRINTKPI).length > 0 && (
                <h1 style={{ fontSize: '12px', fontFamily: 'fontBold' }}>{`${new Date(
                  PRINTKPI.Startdate,
                ).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} - ${new Date(PRINTKPI.Enddate).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} `}</h1>
              )}
            </IconButtonContainer>
          )}
          {statements?.Queries?.CREATE && dashType === 'OOH' && activeCampaign && (
            <IconButtonContainer style={{ gap: '1vw' }}>
              {OOHKPI && Object.keys(OOHKPI).length > 0 && (
                <h1 style={{ fontSize: '12px', fontFamily: 'fontBold' }}>{`${new Date(
                  OOHKPI.Startdate,
                ).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} - ${new Date(OOHKPI.Enddate).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })} `}</h1>
              )}
            </IconButtonContainer>
          )}
        </div>
        {/* </div> */}
        {dashType === DashboardTypes.FLOWCHART && (
          <IconButtonContainer style={{ display: 'flex', alignItems: 'flex-end' }}>
            {!organisationReportActive ? (
              <DarkButton className="publish" style={{ alignSelf: 'flex-end' }} onClick={() => setSeeModal(true)}>
                Add Campaign
              </DarkButton>
            ) : (
              <>
                {anyPublish && <DarkButton onClick={() => setAddCustomReportModal(true)}>Add Custom Report</DarkButton>}
              </>
            )}
          </IconButtonContainer>
        )}
        {dashType !== DashboardTypes.FLOWCHART &&
          activeCampaign &&
          !activeCampaign.authorized &&
          !userCanDoInsource &&
          statements?.Comment?.READ &&
          commentsList?.some((el) => el.placeholder.includes('0')) && (
            <>
              <IconButton title="Comments" onClick={() => setToggleComment(!toggleComment)}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  {comments}
                </span>
                Comments
              </IconButton>
              {commentsList ? (
                <Comments
                  header={true}
                  toggleComment={toggleComment}
                  componentID={dashType === 'DIGITAL' /* || dashType === 'SEARCH' */ ? '0' : `${dashTypeTransformed}0`}
                  setToggleComment={(toggleComment: boolean) => setToggleComment(toggleComment)}
                ></Comments>
              ) : null}
            </>
          )}
      </Content>

      {pickTemplateDisplay && (
        <PickTemplate setPickTemplateDisplay={(arg: any) => setPickTemplateDisplay(arg)}></PickTemplate>
      )}

      {saveTemplateDisplay && (
        <SaveTemplate setSaveTemplateDisplay={(arg: any) => setSaveTemplateDisplay(arg)}></SaveTemplate>
      )}

      {seeModal && (
        <AddCampaignModal setSeeModal={(seeModal: any) => setSeeModal(seeModal)} seeModal={seeModal}></AddCampaignModal>
      )}
      {editCampaign && <EditCampaignModal></EditCampaignModal>}
      {deleteLinkModal && (
        <DeleteConfirmationModal
          handleDeleteConfirmationModal={handleDeleteConfirmationModal}
          modalObject={{
            title: 'Delete All Stored Queries',
            message: 'This will delete all stored queries, are you sure you want to proceed?',
            mainButton: 'Delete',
            secondaryButton: 'Cancel',
          }}
        ></DeleteConfirmationModal>
      )}
      {addCampaignPeriodModal && (
        <AddCampaignPeriodModal setAddCampaignPeriodModal={setAddCampaignPeriodModal}></AddCampaignPeriodModal>
      )}

      {addCustomReportModal && <AddCustomReport setAddCustomReportModal={setAddCustomReportModal}></AddCustomReport>}
    </StyledHeader>
  );
};

export default Header;
